<template>
  <div>
    <div class="card card-header list-group-item list-group-item-action active mb-3">
      <h4 class="mb-0">Cadastro de insumos de produção</h4>
    </div>
    <div class="card">
      <div style="padding:15px;">
          <vs-table
            :data="content">
            <template slot="header" >
              <h3>
                Registros
              </h3>
            </template>
            <template slot="thead">
              <vs-th>
                Insumos de produção
              </vs-th>
              <vs-th style="width:150px;">
                Perídodo
              </vs-th>
              <vs-th style="width:150px;">
               Valor
              </vs-th>
               <vs-th style="width:50px;">
               Aprovação
              </vs-th>
           </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                <vs-td :data="tr.insumoId">
                  {{fnConcat(tr.insumoId)}}
                </vs-td>

                <vs-td :data="tr.periodoId">
                  {{fnConcat2(tr.periodoId)}}
                </vs-td>
                <vs-td :data="tr.valor">
                 R$ {{formataPrice(tr.valor)}}
                </vs-td>
                <vs-td class="text-center">
                  <a
                  class="icone-editar"
                  data-editar
                  title="Benefícios"
                  v-if="!tr.aprovada"
                  @click="fnAprova(tr.etapaId)"
                  >
                    <i class="i-circled i-small i-light"
                    :class="'icon-flag-checkered1'"
                    :style="'background:#8fc4a5;'"
                    ></i>
                  </a>                  
                  <a
                  class="icone-editar"
                  data-editar
                  title="Benefícios"
                  v-else
                  >
                    <i class="i-circled i-small i-light"
                    :class="'icon-checkbox-checked'"
                    :style="'background:#ccc; color:#888'"
                    ></i>
                  </a>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
      </div>
    </div>
  </div>
</template>

<script>
  import { getSuccess,formatPrice,clientKey } from "@/global/utils";

  export default {
    data() {
      return {
        content:[],
        cadastro:{
        } ,
        insumos:{},
        periodos:{},
        incluindo:false,
        iconArea: 48 * 2,
        titulo:'',
        tipo:'',
        cadastroid:null
      }
    },
    mounted() {
      this.fnGetContratacao()
      this.fnGetInsumos()
      this.fnGetPeriodos()
    },
    methods: {
      async fnGetInsumos(){
        await this.$http.get('listainsumos/api/')
        .then(res=> {
          this.insumos = res.data
        })
        .catch(()=>{})
    },
      async fnGetPeriodos(){
        await this.$http.get('listaperiodos/api/')
        .then(res=> {
          this.periodos = res.data
        })
        .catch(()=>{})
    },
    formataPrice(val){
      return formatPrice(val)
    },
      async fnAprova(etapaId) {
        const metodo = "put"
        let dados = {
          aprovada: true,
          tsAprovacao: this.$moment().format(),
          EtapaId: etapaId,
          contratacaoId: this.cadastroid
        }
        await this.$http[metodo]("/etapa_08/aprova/" +etapaId, dados)
          .then(() => {
            getSuccess();
             this.fnGetContratacao()
          })
          .catch(() => {});
      },    

      async fnGetContratacao() {
        await this.$http
          .get(`contratacao/codigo/${this.$route.params.codigoContrato}/etapa_08`)
          .then((res) => {
            this.cadastro.contratacaoId = res.data.contratacaoId;
            this.cadastroid = res.data.contratacaoId
            this.content=[]
            if(res.data.contratacoesEVO08 != null){
              var toString = JSON.stringify(res.data.contratacoesEVO08)
               var toJson = JSON.parse(toString)
              for(var i =0; i < toJson.length;i++){
                this.content.push(toJson[i])
              }
            }
          })
          .catch(() => {});
      },
      fnCancela(){
        this.incluindo = false;
        this.titulo = ''
        this.tipo =''

      },
      fnEdicao(val){
        if (val == 'Incluindo'){
          this.incluindo = true;
          this.titulo = 'Incluindo novo registro'
          this.tipo ='Inclusão'
        }
      },
      fnEditar(i){
       this.cadastro = this.content[i]
        },
      fnConcat(val){
        var item = this.insumos.filter((administracoes) => {
          return administracoes.insumoId ==val
        });
        var toString = JSON.stringify(item)
        var toJson = JSON.parse(toString)
        return toJson[0].titulo
    },
      fnConcat2(val){
        var item = this.periodos.filter((data) => {
          return data.periodoId ==val
        });
        var toString = JSON.stringify(item)
        var toJson = JSON.parse(toString)
        return toJson[0].titulo
    },
    convertToken(token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    
        return JSON.parse(jsonPayload);
        },
    async fnDeletar(val) {

        var token = localStorage.getItem(clientKey)
        var dataToken = this.convertToken(token)
      await this.$http.delete(`/etapa_08/${val}/${dataToken.ClienteId}`)
        .then(() => {
          let i = this.content.map(item => item.etapaId).indexOf(val) 
          this.content.splice(i, 1)
          getSuccess();
        })
        .catch(() => {});
    },


    },
  }
</script>

<style lang="scss" scoped>
.card-header {
  h4 {
    color: #fff;
    text-align: center;
  }
}
.expand-user{
  width: 100%;
}
</style>